const LIST_ACTION_TYPES = {
  FETCH_LIST: "FETCH_FEEDBACKS",
  FETCH_LIST_REQUEST: "FETCH_FEEDBACKS_REQUEST",
  FETCH_LIST_SUCCESS: "FETCH_FEEDBACKS_SUCCESS",
  FETCH_LIST_FAILURE: "FETCH_FEEDBACKS_FAILURE",
  INVALIDATE_LIST: "INVALIDATE_FEEDBACKS",
}

export default LIST_ACTION_TYPES
